module.exports = new __parcel__URL__("ai-premium-upsell.b942d6b5.svg").toString();